module.exports = __webpack_public_path__ + "img/e_2_18_r.184ecf7b.png";